import { useEffect, useState } from "react";
import {
  Inbox,
  Zap,
  Sparkles,
  Handshake,
  CheckCircle2,
  Cake,
  Mail,
  Clock,
  UserPlus,
  UserCheck,
} from "lucide-react";
import { cn } from "../../../../utils/utils";
import {
  PRESETS_BY_ROLE,
  resolvePresetFilters,
} from "../../constants/filterPresets";
import shopApi from "../../../../api/shopApi";

const ICON_MAP = {
  Inbox,
  Zap,
  Sparkles,
  Handshake,
  CheckCircle2,
  Cake,
  Mail,
  Clock,
  UserPlus,
  UserCheck,
};

const PresetPills = ({
  role,
  activePresetId,
  shopId,
  staffId,
  pipelineStages = [],
  onApplyPreset,
}) => {
  const presets = PRESETS_BY_ROLE[role] || [];
  const [counts, setCounts] = useState({});

  useEffect(() => {
    if (!shopId || !staffId || presets.length === 0) return;
    const controller = new AbortController();

    const payload = presets.map((p) => ({
      id: p.id,
      filters: resolvePresetFilters(p, pipelineStages),
    }));

    shopApi
      .getFilterCounts(shopId, staffId, payload)
      .then((res) => {
        if (res?.status === 1) setCounts(res.data || {});
      })
      .catch(() => {});

    return () => controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, staffId, role, pipelineStages.length]);

  return (
    <div className="flex flex-row items-center gap-1.5 overflow-x-auto no-scrollbar py-0.5">
      {presets.map((preset) => {
        const Icon = ICON_MAP[preset.icon] || Inbox;
        const isActive = activePresetId === preset.id;
        const count = counts[preset.id];
        return (
          <button
            key={preset.id}
            onClick={() =>
              onApplyPreset?.({
                presetId: preset.id,
                resolved: resolvePresetFilters(preset, pipelineStages),
              })
            }
            className={cn(
              "inline-flex items-center gap-1 h-7 px-2.5 rounded-full border text-[12px] font-medium transition-colors whitespace-nowrap",
              isActive
                ? "bg-primary text-white border-primary"
                : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50",
            )}
            title={preset.label}
          >
            <Icon size={14} />
            <span>{preset.label}</span>
            {typeof count === "number" && count > 0 && (
              <span
                className={cn(
                  "ml-0.5 inline-flex items-center justify-center min-w-[16px] h-[16px] px-1 text-[10px] font-semibold rounded-full",
                  isActive ? "bg-white text-primary" : "bg-red-500 text-white",
                )}
              >
                {count > 99 ? "99+" : count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default PresetPills;
